import { EntityType, SelectionStatus } from "sbtech-sports-data-api-contracts";
/* tslint:disable:no-null-keyword */
export const emptySelection = {
    id: "",
    outcomeType: null,
    group: 0,
    name: "",
    title: "",
    betslipLine: "",
    participantMapping: "",
    displayOdds: {},
    trueOdds: 0,
    points: null,
    pointsText: "",
    tags: [""],
    metadata: {},
    isDisabled: true,
    marketId: "",
    odds: "",
    isSelectionInBetslip: false,
    entityType: EntityType.Selection,
    status: SelectionStatus.Disabled,
    eventId: "",
    isEmpty: true
};
export const emptySelectionPointBox = {
    id: "",
    outcomeType: null,
    group: 0,
    name: "",
    title: "",
    betslipLine: "",
    participantMapping: "",
    displayOdds: {},
    trueOdds: 0,
    points: 0,
    pointsText: "",
    tags: [""],
    metadata: {},
    isDisabled: true,
    marketId: "",
    odds: "",
    isSelectionInBetslip: false,
    entityType: EntityType.Selection,
    status: SelectionStatus.Disabled,
    eventId: "",
    isEmpty: true
};
//# sourceMappingURL=emptySelections.js.map